module.exports = __webpack_public_path__ + "static/assets/ec9bbbe4cd938247ffa7bbfb34455ca7.png";